import { Link } from "react-router-dom";
import { Landmark } from "lucide-react";

export const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="grid min-h-screen lg:grid-cols-2">
    <div className="relative hidden overflow-hidden border-r border-border bg-primary lg:block">
      <div className="noise-overlay absolute inset-0 opacity-10" />
      <div className="relative flex h-full flex-col justify-between p-12 text-primary-foreground">
        <Link to="/" className="flex items-center gap-2" data-testid="auth-logo-link">
          <div className="grid h-8 w-8 place-items-center rounded-md bg-white/15">
            <Landmark className="h-4 w-4" />
          </div>
          <span className="font-display text-lg font-extrabold tracking-tight">GrowRupee</span>
        </Link>
        <div>
          <h2 className="font-display text-3xl font-bold tracking-tight lg:text-4xl">
            Turn Bank Statements into Excel, Insights &amp; Actionable Financial Analysis.
          </h2>
          <p className="mt-6 max-w-md text-sm text-white/70">
            Structured table reconstruction, balance validation, categorisation and a review-ready
            credit assessment — all in one workspace.
          </p>
        </div>
        <p className="text-xs text-white/50">
          Your documents are processed for extraction only and remain accessible to your account alone.
        </p>
      </div>
    </div>
    <div className="flex items-center justify-start bg-background px-6 py-16 sm:px-16">
      <div className="w-full max-w-sm">
        <h1 className="font-display text-3xl font-extrabold tracking-tighter">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>
        <div className="mt-10">{children}</div>
        {footer && <div className="mt-8 text-sm text-muted-foreground">{footer}</div>}
      </div>
    </div>
  </div>
);
